import { Order, User, UcPackage } from '../types';

// Dummy user
const dummyUser: User = {
  id: 'usr-123456',
  telegramId: 123456789,
  telegramUsername: 'ggk_1',
  bonusBalance: 500,
  referralCode: 'REF123',
  isBlocked: false
};

// Dummy packages
const dummyPackages: UcPackage[] = [
  {
    id: 'pkg-1',
    amount: 3600,
    price: 4800,
    bonusPoints: 100
  },
  {
    id: 'pkg-2',
    amount: 1800,
    price: 2400,
    bonusPoints: 50
  },
  {
    id: 'pkg-3',
    amount: 600,
    price: 800,
    bonusPoints: 20
  }
];

// Generate dummy orders
export const dummyOrders: Order[] = [
  {
    id: 'ord-1',
    user: dummyUser,
    package: dummyPackages[0],
    orderCode: 'NwXKy8xDnkj',
    amountUc: 3600,
    amountBonus: 100,
    price: 4800,
    status: 'pending',
    paymentId: 'pay-123456',
    paymentUrl: 'https://example.com/pay/123456',
    createdAt: '2025-02-27T17:15:14.000Z'
  },
  {
    id: 'ord-2',
    user: dummyUser,
    package: dummyPackages[1],
    orderCode: 'SKoYqrOpPlz',
    amountUc: 1800,
    amountBonus: 50,
    price: 2400,
    status: 'completed',
    paymentId: 'pay-234567',
    paymentUrl: 'https://example.com/pay/234567',
    createdAt: '2025-02-25T14:30:22.000Z'
  },
  {
    id: 'ord-3',
    user: dummyUser,
    package: dummyPackages[2],
    orderCode: 'HmsToRP7xbO',
    amountUc: 600,
    amountBonus: 20,
    price: 800,
    status: 'failed',
    paymentId: 'pay-345678',
    paymentUrl: 'https://example.com/pay/345678',
    createdAt: '2025-02-20T09:45:33.000Z'
  },
  {
    id: 'ord-4',
    user: dummyUser,
    package: dummyPackages[0],
    orderCode: 'zj11rVvhD3w',
    amountUc: 3600,
    amountBonus: 100,
    price: 4800,
    status: 'completed',
    paymentId: 'pay-456789',
    paymentUrl: 'https://example.com/pay/456789',
    createdAt: '2025-02-15T16:20:11.000Z'
  },
  {
    id: 'ord-5',
    user: dummyUser,
    package: dummyPackages[1],
    orderCode: 'aV75NV16YAK',
    amountUc: 1800,
    amountBonus: 50,
    price: 2400,
    status: 'pending',
    paymentId: 'pay-567890',
    paymentUrl: 'https://example.com/pay/567890',
    createdAt: '2025-02-10T11:05:47.000Z'
  }
];
